import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentHeaderComponent } from './component-header/component-header.component';
import { DropdownModule } from 'primeng/dropdown';
import { GridComponent } from './grid/grid.component';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommentComponent } from './comment/comment.component';
import { DuplicateSampleSelectionComponent } from './duplicate-sample-selection/duplicate-sample-selection.component';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { MultiSelectModule } from 'primeng/multiselect';
import { SidebarModule } from 'primeng/sidebar';
import { MultiplateUpdateComponent } from './multiplate-update/multiplate-update.component';
import { ButtonModule } from 'primeng/button';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { CardModule } from 'primeng/card';
import { ProtocolStepComponent } from './protocol-step/protocol-step.component';
import { SkeletonModule } from "primeng/skeleton";
import { MultiplateQCComponent } from './multiplate-qc/multiplate-qc.component';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { PlateListComponent } from './plate-list/plate-list.component';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SampleBatchingComponent } from './sample-batching/sample-batching.component';
import { SamplePlacementComponent } from './sample-placement/sample-placement.component';
import { CrudTableComponent } from './crud-table/crud-table.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToggleButtonModule } from 'primeng/togglebutton';

@NgModule({
  declarations: [
    CrudTableComponent,
    ComponentHeaderComponent,
    GridComponent,
    CommentComponent,
    DuplicateSampleSelectionComponent,
    MultiplateUpdateComponent,
    ProtocolStepComponent,
    MultiplateQCComponent,
    PlateListComponent,
    SampleBatchingComponent,
    SamplePlacementComponent,
  ],
  imports: [
    CalendarModule,
    CommonModule, 
    DropdownModule,
    DialogModule,
    FormsModule,
    TableModule,
    PanelModule,
    MultiSelectModule,
    SidebarModule,
    ReactiveFormsModule,
    BlockUIModule,
    ButtonModule,
    CheckboxModule,
    ProgressSpinnerModule,
    CardModule,
    SkeletonModule,
    FileUploadModule,
    TooltipModule,
    InputSwitchModule,
    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    ToggleButtonModule
  ],
  exports: [
    CommonModule,
    DropdownModule,
    DialogModule,
    FormsModule,
    TableModule,
    PanelModule,
    ButtonModule,
    BlockUIModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    ComponentHeaderComponent,
    GridComponent,
    CommentComponent,
    DuplicateSampleSelectionComponent,
    MultiSelectModule,
    SidebarModule,
    MultiplateUpdateComponent,
    CardModule,
    ProtocolStepComponent,
    MultiplateQCComponent,
    FileUploadModule,
    TooltipModule,
    PlateListComponent,
    SampleBatchingComponent,
    SamplePlacementComponent,
    CrudTableComponent,
    InputSwitchModule,
    CheckboxModule,
    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    ToggleButtonModule
  ]

})
export class SharedComponentsModule { }
